import React, { useRef, useState, useEffect, useCallback } from 'react';
import CycleAnalyzer from "components/zobject/custom/CycleAnalyzer.js";
import {usePreventDragging} from './preventDragging.js';
import TidalVisualizer from './TidalVisualizer.js';
import {parse, getCycleString} from 'effects/midi/tidal/parser.js';
import { Input } from 'reactstrap';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import {updateParameter} from 'operations/actions.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import { connect } from "react-redux";

const TidalEffectComponent = (props) => {
    let ref = useRef(undefined);
    let [value, setValue] = useState(props.effect.cycleString);
    let [showError, setShowError] = useState(false);
    let [typing, setTyping] = useState(false);

    useEffect(() => {
        setValue(getCycleString(props.cycle));
    }, [setValue, props.cycle]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            submit();
        }
    }, [value, props.effect, setTyping]);

    const submit = useCallback(() => {
        let cycle = parse(value);
        if (cycle && cycle.length > 0) {
            props.sequencerEngine.operationManager.dispatch(
                updateParameter(props.effect.cycleParameter, cycle));
        } else { 
            setShowError(true);
            setTimeout(() => {
                setShowError(false);
            }, 1000);
        }
        setTyping(false);
    }, [props.effect, setShowError, value, setTyping]);

    const onChangeCycleRetrigger = useCallback((e) => {
        let retrigger = e.target.value;
        document.activeElement.blur()
        props.effect.cycleRetrigger = !props.effect.cycleRetrigger;
    }, [props.effect]);

    return (
        <div ref={ref}>
          <div
            onMouseDown={(e) => e.stopPropagation()}
            draggable={true}
            onDragStart={(e) => e.preventDefault()}
            className="tidal-component">
            {!typing && <CycleAnalyzer tidal={props.effect}/>}
            <Input
              value={value}
              onKeyDown={onKeyDown}
              onChange={(event) => {
                  setTyping(true);
                  setValue(event.target.value);
              }}
              placeholder="Output Note"
              className="tidal-input"/>
            <div className="enter-button" onClick={submit}> 
                    Enter
                  </div>
                </div>
                <ConditionedComponent condition={showError}>
                  <div className="error-box">Syntax Error</div>
                </ConditionedComponent>
          {!props.noUI && <TidalVisualizer effect={props.effect}/>}
          {!props.noUI && <div className="tidal-parameters">
                 <EffectParameterSlider
                   effectNumber={props.effectNumber}
                   name={'Cycle Length'}
                   parameter={props.effect.cycleLengthParameter}
                   automation={props.automation}
                   onParameterChanged={props.onParameterChanged}
                   isParameter={true}
                   sequencerEngine={props.sequencerEngine}
                   lfoEnabled={true}
                   step={1}
                   min={4}
                   max={64}/>
                 <EffectParameterSlider
                   effectNumber={props.effectNumber}
                   name={'Speed Factor'}
                   parameter={props.effect.lengthFactorParameter}
                  automation={props.automation}
                  onParameterChanged={props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={props.sequencerEngine}
                  lfoEnabled={true}
                   step={0.5}
                  min={0.5}
                  max={4}/>
            <EffectParameterSlider
                   effectNumber={props.effectNumber}
                   name={'Duration Factor'}
                   parameter={props.effect.durationFactorParameter}
                  automation={props.automation}
                  onParameterChanged={props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={props.sequencerEngine}
                  lfoEnabled={true}
                   step={0.01}
                  min={0.1}
                  max={4}/>
 
            {/*<EffectParameterSlider
                   effectNumber={props.effectNumber}
                   name={'Accent Factor'}
                   parameter={props.effect.accentFactorParameter}
                  automation={props.automation}
                  onParameterChanged={props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={props.sequencerEngine}
                  lfoEnabled={true}
                   step={0.01}
                  min={0}
                  max={8}/>
                 <EffectParameterSlider
                   effectNumber={props.effectNumber}
                   name={'Staccato Factor'}
                   parameter={props.effect.staccatoFactorParameter}
                  automation={props.automation}
                  onParameterChanged={props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={props.sequencerEngine}
                  lfoEnabled={true}
                   step={0.01}
                  min={0}
                  max={2}/>*/}
               {props.effect.variables.map(
                    variable =>
                        <EffectParameterSlider
                          name={variable.name}
                          min={variable.min}
                          max={variable.max}
                          step={1}
                          parameter={variable}
                          lfoEnabled={true}
                          sequencerEngine={props.sequencerEngine}
                          isParameter={true}
                          effectNumber={props.effectNumber}
                    />)}
                          </div>}
        {!props.noUI && 
                <div className="refined-checkbox-preferences">
                      <label>
                        <input 
                               type="checkbox"
                               value="reversed"
                               checked={props.effect.cycleRetrigger}
                               onChange={onChangeCycleRetrigger} />
                          Cycle Retrigger
                      </label>
                </div>}
            </div>
    );
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}

const mapStateToProps = (state, props) => {
    return {
        cycle: props.effect.cycle,
    };
};

export default connect(mapStateToProps, null)(TidalEffectComponent);
